module.exports = __webpack_public_path__ + "static/img/delivery_bike.f8f7d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delivery_bike.png
// module id = cF8G
// module chunks = 0